module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isPendingManagement === true) ? _c('div', {
    staticClass: "box info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Pending Number Of EMI today")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pendingEmiTodayNo))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pending Amount Of EMI today")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pendingEmiTodayAmount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pending Number Of EMI Till today")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pendingEmiTillTodayNo))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pending Amount Of EMI Till today")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pendingEmiTillTodayAmount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Active Customer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalActiveCustomer))])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title text-warning"
  }, [_vm._v("Pending Records")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0872ddb5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/PendingManagement.vue
// module id = 721
// module chunks = 0